import axios from "axios";
import API_BASE_URL from "../config";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});


export const sendMessage = async (formData) => {
  try {
    const res = await axiosInstance.post("send-message", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (err) {
    return {
      error: err.response?.data?.error || "Failed to send message. Please try again.",
    };
  }
};

export const getMessages = async (payload = {}) => {
  try {
    const res = await axiosInstance.post("get-messages", payload);
    return res.data;
  } catch (err) {
    return {
      error: err.response?.data?.error || "Failed to fetch messages. Please try again.",
    };
  }
};

export const getUnreadCount = async (payload = {}) => {
  try {
    const res = await axiosInstance.post("unread-count", payload);
    return res.data;
  } catch (err) {
    return {
      error: err.response?.data?.error || "Failed to fetch unread count. Please try again.",
    };
  }
};

export const markMessagesAsRead = async (payload = {}) => {
  try {
    const res = await axiosInstance.post("mark-read", payload);
    return res.data;
  } catch (err) {
    return {
      error: err.response?.data?.error || "Failed to mark messages as read. Please try again.",
    };
  }
};

export const deleteMessage = async (payload = {}) => {
  try {
    const res = await axiosInstance.post("delete-message", payload);
    return res.data;
  } catch (err) {
    return {
      error: err.response?.data?.error || "Failed to delete message. Please try again.",
    };
  }
};

export const editMessage = async (payload = {}) => {
  try {
    const res = await axiosInstance.post("edit-message", payload);
    return res.data;
  } catch (err) {
    return {
      error: err.response?.data?.error || "Failed to edit message. Please try again.",
    };
  }
};